import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { prop } from '@ipfabric/utils/fp/prop';
import classNames from 'classnames';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { type FC, type MouseEvent, memo } from 'react';
import { useDeviceViewContextSelectors } from '../model/DeviceViewModel';
import { selectEntityTab } from '../model/commands/selectEntityTab';

interface Props {
  active: boolean;
  deviceViewEntityId: DeviceViewEntityId;
  label: string;
  tableId: string;
}

const BareDeviceViewContentTabTable: FC<Props> = (props) => {
  const ctxProps = useDeviceViewContextSelectors({
    dispatch: prop('dispatch'),
  });

  const handleTableChange = useStableCallback((e: MouseEvent) => {
    e.preventDefault();
    ctxProps.dispatch(selectEntityTab, {
      deviceViewEntityId: props.deviceViewEntityId,
      tabId: props.tableId,
    });
  });

  return (
    <li className={classNames(props.active && 'active', 'relative')}>
      {/* biome-ignore lint/a11y/useValidAnchor: legacy code */}
      <a href='#' onClick={handleTableChange}>
        <span>{props.label}</span>
      </a>
      <span
        className={classNames(
          'device-view-collapsible-bottom-bar__tabs-item-border',
          props.active &&
            'device-view-collapsible-bottom-bar__tabs-item-border--active',
        )}
      />
    </li>
  );
};

export const DeviceViewContentTabTable = memo(BareDeviceViewContentTabTable);
